export default __webpack_public_path__ + "static/media/icon-companies.81f1ab1f.svg";